import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { COMMANDS } from '../../../mod-command/constants';
import { sendCommand } from '../../../mod-command/slice';
import { NOTIFICATION_TIMEOUT_TYPE, showNotification } from '../../../notifications';
import Dialog from '../../../base/ui/components/web/Dialog';
import { useTranslation } from 'react-i18next';
const MuteAllVideoDialog = ({ exclude, }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [title, setTitle] = useState(t("dialog.muteEveryoneElsesVideoTitle", { who: t("dialog.SIP") }));
    const [content, setContent] = useState(t("dialog.muteEveryonesVideoDialogSIP"));
    const onSubmit = () => {
        dispatch(sendCommand(COMMANDS.CAM_SIP.COMMAND, COMMANDS.CAM_SIP.OFF));
        dispatch(showNotification({ titleKey: 'notify.mutedVideoAllSIP' }, NOTIFICATION_TIMEOUT_TYPE.SHORT));
        return true;
    };
    return (React.createElement(Dialog, { ok: { translationKey: 'dialog.muteParticipantsVideoButton' }, onSubmit: onSubmit, title: title },
        React.createElement("div", { className: "mute-dialog" }, content)));
};
export default MuteAllVideoDialog;
